module.exports = __webpack_public_path__ + "static/n95-mask-china-quality-c195c12b6f4bc3b0fa0dcb5eaa038e40.png";